import Page from 'components/Page';
import React from 'react';
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
  UncontrolledButtonDropdown,
} from 'reactstrap';
import CardBlock from 'reactstrap/es/CardBlock';
import BasePage from './BasePage';
import Global, {DD_MM_YYYY_HH_MM_SS} from '../utils/Global';
import {deleteParam, isEmpty, parseDate, sortirMap} from '../utils/Utilities';
import {MdDelete, MdEdit} from 'react-icons/md';
import ConfirmDialog from '../components/modal/ConfirmDialog';
import ActiveOption from '../components/Widget/ActiveOption';
import ItemOption from '../components/Widget/ItemOption';
import Pagination from '../components/Pagination';
import queryString from 'query-string';
import ActiveLabel from '../components/Widget/ActiveLabel';
// import label from '../message/Label'
import label from 'enqc-utilities/src/label/Label'
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";
import {delegateObjectsForSelection} from "enqc-utilities/src/utils/Utilities";
import DropdownInput from "../components/form/DropdownInput";


const tableTypes = ['', 'bordered', 'striped', 'hover'];


class CityPage extends BasePage{
  constructor(props) {
    super(props);
    this.state = {
      cities : [],
      city:{},
      provinces : [],
      province:{},
      modalAddConfirm:false,
      modalDeleteConfirm:false,
      modal: false,
      ascending:true,
      sortir:'name',
      page :queryString.parse(this.props.query).page?queryString.parse(this.props.query).page:1,
      totalPage:0,
      totalElement:0,
      pageElement:0,
    }
  }

  componentWillReceiveProps(props, nextContext) {
    if(props!=this.props){
      this.setState({
        page:queryString.parse(props.query).page?queryString.parse(props.query).page:1
      }, () => {
        this.fetchAll()
      })
    }
  }


  componentDidMount() {
    super.componentDidMount();
    this.fetchAll()
    this.fetchProvinces()
  }

  confirmSave = () =>{
    let {city, province} = this.state
    if(isEmpty(city.name) || isEmpty(province)){
      this.showDialog(label.Warning, label.PleaseCompleteTheFields)
    }else{
      this.setState({
        modalAddConfirm:true
      })
    }
  }

  save = () => {
    let {city, province} = this.state
    city.province = province
    if(!city.id && !city.active){
      city.active = false ;
    }

    this.setState({
      modalAddConfirm:false
    }, () => {
      this.post(Global.API.CITY_SAVE, city, null, res => {
        if(res.code===200){
          this.setState({
            city:{}
          }, () => {
            this.fetchAll()
          })
        }
      }, true, true);
    })
  }

  confirmDelete = () =>{
    this.setState({
      modalDeleteConfirm:true
    })
  }

  delete = () => {
    this.setState({
      modalDeleteConfirm:false
    }, () => {
      this.get(Global.API.CITY_DELETE+"/"+this.state.city.id, null, null, res => {
        if(res.code===200){
          this.setState({
            city:{}
          }, () => {
            this.fetchAll()
          })
        }
      },true, true);
    })
  }

  closeDialog = () =>{
    this.setState({
      modalAddConfirm:false,
      modalDeleteConfirm:false
    })
  }

  fetchAll = () => {
    this.get(Global.API.CITIES, {
      params:{
        provinceId:this.state.province.id,
        ascending:this.state.ascending,
        sortir:this.state.sortir,
        page:this.state.page-1
      }
    }, null, response=>{
      if(response.code === 200){
        this.setState({
          cities : response.data,
          totalPage: response.totalPage,
          totalElement: response.totalElement,
          pageElement: response.pageElement,
        })
      }
    }, true, true);
  }

  refresh = (ascending, sortir) => (
      this.setState({
        ascending:ascending,
        sortir:sortir
      }, () => {
        this.fetchAll()
      })
  )

  fetchProvinces = () => {
    this.get(Global.API.PROVINCES, {
      params:{
        ascending:true,
        sortir:'name'
      }
    }, null, response=>{
      if(response.code === 200){
        this.setState({
          provinces : response.data
        })
      }
    }, true, true);
  }


  render() {
    let provinces = this.state.provinces
    let province = this.state.province
    let {ascending, sortir} = this.state
    let orderOptions = delegateObjectsForSelection(
        {name:label.Name, field:'name'},
        {name:label.Created, field:'created'},
        {name:label.Updated, field:'updated'}
    )
    let ascendingOptions = delegateObjectsForSelection( {name:label.Ascending, field:true},{name:label.Descending, field:false})

    return (
        <Page
            title={label.City}
            breadcrumbs={[{ name: label.City, active: true }]}
            className="TablePage">
          {super.render()}
          <ConfirmDialog
              showing={this.state.modalAddConfirm}
              title={label.UpdateConfirmation}
              message={label.UpdateConfirmationMessage}
              okCallback={this.save}
              cancelCallback={this.closeDialog}/>
          <ConfirmDialog
              showing={this.state.modalDeleteConfirm}
              title={label.DeleteConfirmationTitle}
              message={label.DeleteConfirmationMessage}
              okCallback={this.delete}
              cancelCallback={this.closeDialog}/>
          <Row key={1}>
            <Col>
              <Card>
                <CardHeader>{label.City}</CardHeader>
                <CardBody >
                  <Row>
                    <Col md={3}>
                      <Card>
                        <PrimaryCardHeader content={label.BasicInformation}/>
                        <CardBody>
                          <Row>
                            <CardBlock>
                              <FormGroup>
                                <Label for="name">{label.Name}</Label>
                                <Input
                                    type="text"
                                    name="name"
                                    value={!isEmpty(this.state.city.name)?this.state.city.name:""}
                                    onChange={(e) =>{
                                      let ctg = this.state.city
                                      if(ctg!=null){
                                        ctg.name = e.target.value
                                        this.setState({
                                          city:ctg
                                        })
                                      }
                                    }}
                                    placeholder={label.EnterCityName}
                                />
                              </FormGroup>
                              <FormGroup>
                                <ItemOption
                                    title={label.SelectProvince}
                                    objects={provinces}
                                    default={province!=null?province.id:null}
                                    noTranslation={true}
                                    callback={(province)=>{
                                      if(province!=null){
                                        this.setState({
                                          province:province
                                        }, () => {
                                          deleteParam(this.props, 'page')
                                        })
                                      }else{
                                        this.setState({
                                          province:{}
                                        }, () => {
                                          deleteParam(this.props, 'page')
                                        })
                                      }
                                    }}
                                />
                              </FormGroup>
                              <FormGroup>
                                <ActiveOption
                                    default={this.state.city.active}
                                    callback={(active)=>{
                                      let ctg = this.state.city
                                      if(ctg!=null){
                                        ctg.active = active
                                        this.setState({
                                          city:ctg
                                        })
                                      }

                                    }}
                                />
                              </FormGroup>
                            </CardBlock>
                          </Row>
                          <Row>
                            <Col>
                              <ButtonGroup className="float-left">
                                <Button color="danger" onClick={e => (
                                    this.setState({
                                      city:null
                                    })
                                )}>{label.Cancel}</Button>
                              </ButtonGroup>
                            </Col>
                            <Col>
                              <ButtonGroup className="float-right">
                                <Button color="primary" onClick={e=>(
                                    this.confirmSave()
                                )}> {
                                  (this.state.city!=null && this.state.city.id!=null)?label.Update:label.Add
                                } </Button>

                              </ButtonGroup>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={9}>
                      <Card body>
                        <Row>
                          <Col md={6}>
                            <ButtonGroup className="d-flex w-100">
                              <DropdownInput
                                  title={label.SortBy}
                                  options={orderOptions}
                                  onSelect={(item) => {
                                    this.refresh(ascending, item.field, true)
                                  }}
                                  onReset={() => {
                                    this.refresh(ascending, "created", true)
                                  }}/>
                              &nbsp;&nbsp;&nbsp;
                              <DropdownInput
                                  options={ascendingOptions}
                                  onSelect={(item) => {
                                    this.refresh(item.field, sortir, true)
                                  }}
                                  onReset={() => {
                                    this.refresh(true, sortir, true)
                                  }}/>
                            </ButtonGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <ItemOption
                                  title={label.SelectProvince}
                                  objects={provinces}
                                  default={province!=null?province.id:null}
                                  noTranslation={true}
                                  hideLabel={true}
                                  callback={(province)=>{
                                    if(province!=null){
                                      this.setState({
                                        province:province
                                      }, () => {
                                        deleteParam(this.props, 'page')
                                      })
                                    }else{
                                      this.setState({
                                        province:{}
                                      }, () => {
                                        deleteParam(this.props, 'page')
                                      })
                                    }
                                  }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Table responsive hover>
                              <thead>
                              <tr>
                                <th>#</th>
                                <th>{label.Name}</th>
                                <th>{label.Province}</th>
                                <th>{label.Status}</th>
                                <th>{label.Updated}</th>
                                <th>{label.Edit}</th>
                              </tr>
                              </thead>
                              <tbody>
                              {
                                this.state.cities.map((item, index) =>(
                                    <tr key={index}>
                                      <th scope="row">{((this.state.page-1)* this.state.pageElement)+(++index)}</th>
                                      <td>{item.name}</td>
                                      <td>{item.province.name}</td>
                                      <td><ActiveLabel active={item.active}/></td>
                                      <td>{parseDate(item.updated, DD_MM_YYYY_HH_MM_SS)}</td>
                                      <td>
                                        <Button color="danger" onClick={e => {
                                          this.setState({
                                            city:item
                                          }, () => {
                                            this.confirmDelete()
                                          })
                                        }}>
                                          <MdDelete/>
                                        </Button>
                                        &nbsp;
                                        <Button color="primary" onClick={e=>(
                                            this.setState({
                                              city:item
                                            })
                                        )}>
                                          <MdEdit/>
                                        </Button>
                                      </td>
                                    </tr>
                                ))
                              }
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
                <Pagination {...this.props} currentPage={parseInt(this.state.page)} pageCount={this.state.totalPage} />
              </Card>
            </Col>
          </Row>
        </Page>
    );
  }
}

export default Object.assign(CityPage, {ENDPOINT : "/cities"})
